import { render, staticRenderFns } from "./yetSelectWard.vue?vue&type=template&id=60b5fa04&scoped=true&"
import script from "./yetSelectWard.vue?vue&type=script&lang=js&"
export * from "./yetSelectWard.vue?vue&type=script&lang=js&"
import style0 from "./yetSelectWard.vue?vue&type=style&index=0&id=60b5fa04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5fa04",
  null
  
)

export default component.exports